<template>
  <div>
    <el-page-header @back="goBack">
      <template #title>
        Tareas del proyecto
        {{ ProyectoStore.ProyectoSelected.Descripcion }}</template
      >
      <template #default>
        <div>
          <el-table
            class="main-table"
            ref="tableTareas"
            :data="
              TareasStore.GestionTareas.sort((a, b) =>
                b.TipoTarea.localeCompare(a.TipoTarea)
              )
            "
            style="width: 100%"
            empty-text="No hay datos"
            :height="windowHeight - 50"
            size="small"
            stripe
            scrollbar-always-on
            row-key="Id"
            default-expand-all
            :span-method="spanRowsPAs"
            :loading="loadingTareas"
          >
            >
            <el-table-column
              prop="Descripcion"
              label="Descripcion"
              show-overflow-tooltip
            />
            <el-table-column
              label="Fase"
              prop="FaseText"
              width="200"
              show-overflow-tooltip
            />
            <el-table-column
              label="Departamento"
              prop="Departamento"
              width="200"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column label="Asignado a" width="300">
              <template #default="{ row }">
                <div style="display: flex; align-items: center">
                  <div
                    v-if="!row.AsignadoA || row.AsignadoA.trim().length === 0"
                  ></div>
                  <div v-else style="display: flex; flex-direction: column">
                    <mgt-person
                      v-for="p in row.AsignadoA.split(';')"
                      :key="p"
                      :user-id="p"
                      view="oneline"
                      person-card="hover"
                      fetch-image
                    ></mgt-person>
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              property="FechaInicio"
              label="Fecha inicio"
              :formatter="dateToStringFormatter"
            />
            <el-table-column
              property="FechaFin"
              label="Fecha fin"
              :formatter="dateToStringFormatter"
            />
            <el-table-column
              property="FechaCaducidad"
              label="Fecha caducidad"
              :formatter="dateToStringFormatter"
            />
            <el-table-column
              label="Completada"
              prop="Completada"
              width="120"
              align="center"
            >
              <template #default="{ row }">
                <el-switch
                  v-if="MostrarSwitchCompletar(row)"
                  v-model="row.Completada"
                  disabled
                />
                <el-popconfirm
                  v-else-if="MostrarBotonCompletar(row)"
                  width="220"
                  :icon="WarningFilled"
                  icon-color="#E00D0D"
                  title="¿Seguro que deseas completar la tarea?"
                  @confirm="completarTarea(row)"
                >
                  <template #reference>
                    <el-button size="small" type="danger" round>
                      Completar
                    </el-button>
                  </template>
                  <template #actions="{ confirm, cancel }">
                    <el-button round size="small" @click="cancel">No</el-button>
                    <el-button round type="danger" size="small" @click="confirm"
                      >Si</el-button
                    >
                  </template>
                </el-popconfirm>
              </template>
            </el-table-column>
            <el-table-column label="" width="150">
              <template #default="{ row }">
                <el-button
                  v-if="!row.children"
                  type="danger"
                  size="small"
                  :icon="Edit"
                  round
                  @click="EditarTarea(row)"
                  >Detalles</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
      </template>
    </el-page-header>
  </div>

  <el-dialog v-model="dialogTareasVisible" title="Editar tarea" width="600">
    <el-form
      label-width="30%"
      label-position="left"
      :model="formTarea"
      :disabled="!editarFormulario"
      @submit.prevent="handleSubmit"
    >
      <el-form-item label="Descripción" prop="Descripcion" required>
        <el-input v-model="formTarea.Descripcion" />
      </el-form-item>
      <el-form-item label="Departamento" prop="Departamento">
        <el-input v-model="formTarea.Departamento" />
      </el-form-item>
      <el-form-item label="Fase" prop="Fase">
        <select
          :disabled="!editarFormulario"
          v-model="formTarea.Fase"
          placeholder="Selecciona Fase"
          class="el-select el-select__wrapper"
        >
          <option
            v-for="fase in fases"
            :key="fase.Id"
            :label="fase.Descripcion"
            :value="fase.Id"
          />
        </select>
      </el-form-item>
      <el-form-item label="Tipo tarea" prop="TipoTarea">
        <select
          :disabled="!editarFormulario"
          v-model="formTarea.TipoTarea"
          placeholder="Selecciona tipo"
          class="el-select el-select__wrapper"
        >
          <option
            v-for="tipo in tiposTareas"
            :key="tipo"
            :label="tipo"
            :value="tipo"
          />
        </select>
      </el-form-item>
      <el-form-item
        v-if="formTarea.TipoTarea === 'PA'"
        label="SAP Autoconsumo"
        prop="SAPAutoConsumo"
      >
        <el-switch v-model="formTarea.SAPAutoConsumo" />
      </el-form-item>
      <el-form-item label="Dependencia" prop="Dependencia">
        <select
          :disabled="!editarFormulario"
          v-model="formTarea.Dependencia"
          placeholder="Selecciona"
          class="el-select el-select__wrapper"
        >
          <option label=" 0 - Sin dependecia" :value="0" />
          <option
            v-for="tarea in tareasDependencia"
            :key="tarea.IdOrigen"
            :label="tarea.Descripcion"
            :value="tarea.IdOrigen"
          />
        </select>
      </el-form-item>
      <el-form-item label="Asignado a">
        <mgt-people-picker
          ref="mgtPeoplePicker"
          id="mgtPeoplePicker"
          type="person"
          class="people-picker"
          :disabled="!editarFormulario"
        />
      </el-form-item>
      <el-form-item label="Fecha inicio" prop="FechaInicio">
        <el-date-picker
          v-model="formTarea.FechaInicio"
          :picker-options="pickerOptions"
          type="date"
          format="DD/MM/YYYY"
          placeholder="Seleccionar fecha"
        />
      </el-form-item>
      <el-form-item label="Fecha caducidad" prop="FechaCaducidad">
        <el-date-picker
          v-model="formTarea.FechaCaducidad"
          :picker-options="pickerOptions"
          type="date"
          format="DD/MM/YYYY"
          placeholder="Seleccionar fecha"
        />
      </el-form-item>
      <el-form-item label="Fecha fin" prop="FechaFin">
        <el-date-picker
          disabled
          v-model="formTarea.FechaFin"
          :picker-options="pickerOptions"
          type="date"
          format="DD/MM/YYYY"
          placeholder=""
        />
      </el-form-item>
      <el-form-item label="Completada por">
        <mgt-people-picker
          ref="mgtPeoplePickerCompletado"
          id="mgtPeoplePickerCompletado"
          class="people-picker"
          disabled
        />
      </el-form-item>
    </el-form>
    <template #footer>
      <div class="dialog-footer">
        <el-button round class="buttonIdilia-light" @click="CancelDialog"
          >Cancelar</el-button
        >
        <el-button
          round
          class="buttonIdilia"
          @click="ConfirmDialog"
          v-if="!formTarea.Completada"
          >Guardar</el-button
        >
      </div>
    </template>
  </el-dialog>
</template>

<script lang="ts" setup>
// import { computed, onMounted, ref } from "vue";
// import { ElInput, ElTable, ElTableColumn } from "element-plus";
import { ref, onMounted, reactive, computed } from "vue";
import { useRoute, useRouter } from "vue-router";
import { Edit } from "@element-plus/icons-vue";
import { WarningFilled } from "@element-plus/icons-vue";
// import { Roles, useCommonStore } from "@/store/CommonStore";
import {
  GestionTareasTable,
  TareaBBDD,
  TiposTareas,
  useTareasStore,
} from "@/store/TareasStore";
import { useProyectosStore } from "@/store/ProyectosStore";
import Helper from "@/common/Helper";
import { useFasesStore } from "@/store/FaseStore";
import { User, useUserStore } from "@/store/UserStore";
import { registerMgtPeoplePickerComponent } from "@microsoft/mgt";
import { Roles } from "@/store/CommonStore";
import { TableColumnCtx } from "element-plus";
import { useProductosAcabadoStore } from "@/store/ProductosAcabadoStore";
registerMgtPeoplePickerComponent();
const router = useRouter();
const route = useRoute();
const { dateToStringFormatter } = Helper();
const FaseStore = useFasesStore();
const fases = computed(() => FaseStore.Fases);
const tiposTareas = computed(() => Object.values(TiposTareas));
const tareasDependencia = computed(() => {
  return TareasStore.GestionTareasListado;
});
const UserStore = useUserStore();
const TareasStore = useTareasStore();
const ProyectoStore = useProyectosStore();
const productosAcabadosStore = useProductosAcabadoStore();
const MostrarSwitchCompletar = (row: GestionTareasTable) => {
  if (row.Completada) return true;
  if (row.children) return false;
  if (
    (!(
      UserStore.userRoles.includes(Roles.Admin) ||
      UserStore.userRoles.includes(Roles.Manager)
    ) &&
      !row.AsignadoA) ||
    !(
      row.AsignadoA &&
      row.AsignadoA.split(";").includes(UserStore.CurrentUser.id)
    )
  )
    return true;
  return false;
};
const MostrarBotonCompletar = (row: GestionTareasTable) => {
  if (row.children) return false;
  if (row.Completada) return false;
  if (
    UserStore.userRoles.includes(Roles.Admin) ||
    UserStore.userRoles.includes(Roles.Manager)
  )
    return true;
  if (
    row.AsignadoA &&
    row.AsignadoA.split(";").includes(UserStore.CurrentUser.id)
  )
    return true;
  return false;
};

const loading = ref(false);
const dialogVisibleConfirmCompletada = ref(false);

const pickerOptions = ref({
  firstDayOfWeek: 1,
});
const formTareaEmpty: TareaBBDD = {
  Id: 0,
  IdOrigen: 0,
  IdProyecto: 0,
  IdPA: 0,
  IdMaterial: 0,
  Dependencia: "",
  Fase: 0,
  TipoTarea: "",
  Descripcion: "",
  FechaInicio: "",
  FechaCaducidad: "",
  Completada: false,
  Departamento: "",
  AsignadoA: "",
  FechaFin: "",
  TareaActiva: false,
  SAPAutoConsumo: false,
};
const formTarea = reactive<TareaBBDD>(formTareaEmpty);
const dialogTareasVisible = ref(true);
const windowHeight = window.innerHeight - 150;
const loadingTareas = ref(false);
const editarFormulario = ref(false);
export interface SpanMethodProps {
  row: TareaBBDD;
  column: TableColumnCtx<TareaBBDD>;
  rowIndex: number;
  columnIndex: number;
}
const spanRowsPAs = ({ row }: SpanMethodProps) => {
  if (!row.FechaInicio && !row.FechaCaducidad && row.IdOrigen === 0) {
    return [1, 6];
  }
};
const goBack = () => {
  if (window.history.length > 2) {
    router.go(-1);
  } else {
    // Redirige a una ruta específica si no hay historial
    router.push("/");
  }
};
const EditarTarea = (row: GestionTareasTable) => {
  if (
    (UserStore.userRoles.includes(Roles.Admin) ||
      UserStore.userRoles.includes(Roles.Manager)) &&
    !row.Completada
  ) {
    editarFormulario.value = true;
  } else {
    editarFormulario.value = false;
  }
  const peoplePicker = document.getElementById("mgtPeoplePicker") as any;
  if (
    peoplePicker &&
    row.AsignadoA !== null &&
    String(row.AsignadoA).trim() !== ""
  ) {
    peoplePicker.selectUsersById(String(row.AsignadoA).split(";"));
  }

  const peoplePickerCompletado = document.getElementById(
    "mgtPeoplePickerCompletado"
  ) as any;
  if (
    peoplePickerCompletado &&
    row.CompletadaPor !== null &&
    String(row.CompletadaPor).trim() !== ""
  ) {
    peoplePickerCompletado.selectUsersById(
      String(row.CompletadaPor).split(";")
    );
  }
  Object.assign(formTarea, row);
  dialogTareasVisible.value = true;
};
const CancelDialog = () => {
  dialogTareasVisible.value = false;
  const peoplePicker = document.getElementById("mgtPeoplePicker") as any;
  peoplePicker.selectedPeople = [];
  const peoplePickerCompletado = document.getElementById(
    "mgtPeoplePickerCompletado"
  ) as any;
  peoplePickerCompletado.selectedPeople = [];
};
const ConfirmDialog = async () => {
  const peoplePicker = document.getElementById("mgtPeoplePicker") as any;
  const data = peoplePicker.selectedPeople;
  if (data.length > 0) {
    formTarea.AsignadoA = peoplePicker.selectedPeople
      .map((user: User) => user.id)
      .join(";");
  }
  loadingTareas.value = true;
  if (formTarea.TipoTarea !== "PA") formTarea.SAPAutoConsumo = false;
  await TareasStore.UpdateTarea(formTarea);
  await TareasStore.GetByIdProyecto(Number(route.params.Pid));
  loadingTareas.value = false;
  dialogTareasVisible.value = false;
};
const handleSubmit = (event: Event) => {
  event.preventDefault();
};

const completarTarea = async (tarea: TareaBBDD) => {
  const tareaUpdate = TareasStore.GestionTareasListado.find(
    (t) => t.Id === tarea.Id
  );
  if (tareaUpdate) {
    loading.value = true;
    tareaUpdate.FechaFin = new Date().toISOString();
    tareaUpdate.Completada = true;
    tareaUpdate.CompletadaPor = UserStore.CurrentUser.id;
    await TareasStore.UpdateTarea(tareaUpdate);
    await TareasStore.GetByIdProyecto(tareaUpdate.IdProyecto);
    // Si la tarea tiene SAP AUtoconsumo marcado, se lanza a SAP
    if (tareaUpdate.SAPAutoConsumo) {
       // Llamar a SAP para recuperar el coste estandar y actualizarlo
    const pa = await productosAcabadosStore.GetProductosAcabadosByIds([tareaUpdate.IdPA]);
    if (pa && pa.data && pa.data.length > 0) {
      await productosAcabadosStore
        .GetSAPDataByReference(pa.data[0].Codigo)
        .then((response) => {
          if (response) {
            pa.data[0].CosteEstandarUMB = Number(parseFloat(response).toFixed(2));
            productosAcabadosStore.UpdateProductoAcabado(pa.data[0]);
          }
        })
        .catch((error: Error) => {
          console.error("Error al obtener datos de SAP:", error);
        });
    }
      TareasStore.SAPAutoconsumo(tareaUpdate);
    }
    await TareasStore.NotificarTareas(
      ProyectoStore.ProyectoSelected,
      null,
      null,
      tareaUpdate
    );
    await TareasStore.GetAllTareasPendientes(tareaUpdate.IdProyecto);
  }
  dialogVisibleConfirmCompletada.value = false;
  loading.value = false;
};

onMounted(async () => {
  dialogTareasVisible.value = false;
  loadingTareas.value = true;
  await TareasStore.GetByIdProyecto(Number(route.params.Pid));
  loadingTareas.value = false;
});
</script>
